export const audio3 = "12svB62_Y4ZJb_h91GF0mwW8zPtYZR0lw";
export const intro3 = "";

export const vocab3 = {
    yes: ['shì de', '是的'],
    no: ['bù', '不'],
    not: ['bù', '不'],
    younger: ['xiǎo', '小'],
    older: ['dà', '大'],
    woman: ['nǚrén', '女人'],
    man: ['nánrén', '男人'],
    girl: ['nǚhái', '女孩'],
    boy: ['nánhái', '男孩'],
    is: ['', ''],
    the: ['', ''],
    than: ['', ''],
    'compared to': ['bǐ', '比'],
    '?': ['ma?', '吗？'],
    '!': ['!', '！'],
    ',': [',', '，'],
    '.': ['.', '。'],
};

function question(personOne: string, adj: string, personTwo: string) {
    return {
        literal: [personOne, 'compared to', personTwo, adj, '?'],
        translated: ['is', 'the', personOne, adj, 'than', 'the', personTwo, '?']
    };
}

function posAnswer(personOne: string, adj: string, personTwo: string) {
    return {
        literal: ['yes', ',', personOne, 'compared to', personTwo, adj, '!'],
        translated: ['yes', ',', 'the', personOne, 'is', adj, 'than', 'the', personTwo, '!']
    };
}

function negAnswer(personOne: string, adj: string, personTwo: string) {
    return {
        literal: ['no', ',', personOne, 'not', 'compared to', personTwo, adj, '!'],
        translated: ['no', ',', 'the', personOne, 'is', 'not', adj, 'than', 'the', personTwo, '!']
    };
}

export const lesson3 = [
    question('girl', 'younger', 'woman'),
    posAnswer('girl', 'younger', 'woman'),
    question('boy', 'younger', 'man'),
    posAnswer('boy', 'younger', 'man'),
    question('girl', 'older', 'woman'),
    negAnswer('girl', 'older', 'woman'),
    question('boy', 'older', 'man'),
    negAnswer('boy', 'older', 'man'),
    question('girl', 'younger', 'man'),
    posAnswer('girl', 'younger', 'man'),
    question('boy', 'younger', 'woman'),
    posAnswer('boy', 'younger', 'woman'),
    question('girl', 'older', 'man'),
    negAnswer('girl', 'older', 'man'),
    question('boy', 'older', 'woman'),
    negAnswer('boy', 'older', 'woman'),
];